import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const MAINTENANCE_HISTORY_REPORT_CONFIG: ReportConfig = {
  id: 'maintenance-history',
  title: 'Maintenance History Report',
  permissions: {
      view: PERMISSIONS.GSE.REPORTS.MAINTENANCE_HISTORY.VIEW,
      export: PERMISSIONS.GSE.REPORTS.MAINTENANCE_HISTORY.EXPORT,
    },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search'
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range'
    },
    {
      type: 'dropdown',
      field: 'equipment',
      label: 'Equipment Name',
      placeholder: 'Equipment name',
      width: 'xl',
    },
    {
      type: 'dropdown',
      field: 'technician',
      label: 'Technician',
      placeholder: 'Technician',
      width: 'xl',
    },
    {
      type: 'dropdown',
      field: 'maintenanceType',
      label: 'Maintenance Type',
      placeholder: 'Maintenance Type',
      width: 'xxl',
    }
  ],

  columns: [
    {
      field: 'jobCardId',
      header: 'Job Card ID',
      type: 'text',
      width: '10%',
    },
    {
      field: 'startDate',
      header: 'Start Date',
      type: 'text',
      pipes: ['date'],
      width: '11%',
    },
    {
      field: 'endDate',
      header: 'End Date',
      type: 'text',
      pipes: ['date'],
      width: '11%',
    },
    {
      field: 'equipmentName',
      header: 'Equipment Name',
      type: 'text',
      width: '18%',
    },
    {
      field: 'maintenanceType',
      header: 'Maintenance Type',
      type: 'text',
      pipes: ['formatStatus', 'replaceUnderscore', 'titlecase'],
      width: '16%',
    },
    {
      field: 'spareParts',
      header: 'Spare Parts',
      type: 'text',
      width: '18%',
    },
    {
      field: 'technician',
      header: 'Technicians',
      type: 'text',
      width: '16%',
    },
  ],
};
